// Rotulos das acoes do dropdown de aceite. Fica num modulo sem dependencias para o reducer poder
// importar: importar do ActionDropdown criaria ciclo com o store (src/utils/store -> init-redux)
export const dropdownOptions = {
  ACCEPT_ALL: 'Aceitar sem avarias',
  ACCEPT_ALL_AND_DAMAGED: 'Aceitar com avarias',
  ACCEPT_EVERYTHING: 'Aceitar tudo',
  REJECT_ALL: 'Rejeitar tudo',
  PARTIAL: 'Parcial',
  ACCEPT_MAXIMUM: 'Aceitar máximo',
}
